export default __webpack_public_path__ + "static/media/arrow-right.6e4c2dca.svg";